/* 商品一覧（2026-10-06）。味を選ぶ欄と札（チャイ・出汁ソルト）の組み合わせから、カートに入れる選択肢と価格を決める。
   カートに入れる動きは kz-buy.js（TOP と同じ）。ここでは hidden の id と価格・ボタンの可否だけを変える。 */
(() => {
  const init = (form) => {
    if (form.dataset.kzlReady) return;
    form.dataset.kzlReady = '1';
    const vj = form.querySelector('[data-kzl-variants]');
    if (!vj) return;
    const variants = JSON.parse(vj.textContent);
    const hid = form.querySelector('input[type="hidden"][name="id"]');
    const price = form.querySelector('[data-kz-price]');
    const btn = form.querySelector('[data-kz-add]');
    const status = form.querySelector('.kz-buy__status');
    const groups = [...form.querySelectorAll('[data-kzl-opt]')];
    const pickedOf = (g) => { const s = g.querySelector('select'); if (s) return s.value; const c = g.querySelector('input:checked'); return c ? c.value : null; };
    const sync = (anim) => {
      const picked = [];
      groups.forEach((g) => { picked[Number(g.dataset.kzlOpt)] = pickedOf(g); });
      const v = variants.find((x) => x.o.every((o, i) => o === picked[i]));
      if (v && hid) hid.value = v.id;
      if (v && price && price.textContent !== v.p) {
        price.textContent = v.p;
        if (anim) { price.classList.remove('is-flip'); void price.offsetWidth; price.classList.add('is-flip'); }
      }
      if (btn) btn.disabled = !v || !v.a;
      if (status) status.textContent = v ? (v.a ? '' : 'この組み合わせは、ただいま品切れです') : 'この組み合わせはありません';
      groups.forEach((g) => {
        const oi = Number(g.dataset.kzlOpt);
        g.querySelectorAll('input, option').forEach((el) => {
          const ok = variants.some((x) => x.a && x.o[oi] === el.value && x.o.every((o, i) => i === oi || o === picked[i]));
          const chip = el.closest('.kz-chip');
          if (chip) chip.classList.toggle('is-off', !ok);
        });
      });
    };
    form.addEventListener('change', () => sync(true));
    sync(false);
  };
  const run = () => document.querySelectorAll('[data-kzl-combo]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
